class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static texts = {
        t0: window.free_shipping_text.free_shipping_message,
        t1: window.free_shipping_text.free_shipping_message_1,
        t2: window.free_shipping_text.free_shipping_message_2,
        t3: window.free_shipping_text.free_shipping_message_3,
        t4: window.free_shipping_text.free_shipping_message_4,
    }

    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';

    connectedCallback() {
        this.type = this.dataset.shippingType; // "default" ou "region"
        // PG: permite meta customizada via data-goal-price (ex.: KIT Instalação grátis acima de R$100)
        this.goalPrice = this.dataset.goalPrice
            ? parseInt(this.dataset.goalPrice)
            : (this.type === 'region'
                ? parseInt(window.free_shipping_price_regions)
                : parseInt(window.free_shipping_price));

        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';

        this.addEventListener('change', this.onCartChange.bind(this));
        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.calculateProgress(cart);
        });
    }

    onCartChange() {
        this.initialize();
    }

    calculateProgress(cart) {
        let totalPrice = cart.total_price;

        if (document.body.classList.contains('setup_shipping_delivery')) {
            const giftCardItems = document.querySelectorAll(".cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]");
            giftCardItems.forEach(function(item) {
                const priceGiftCard = item.getAttribute("data-price-gift-card");
                if (priceGiftCard) {
                    totalPrice -= parseFloat(priceGiftCard);
                }
            });
        }

        const cartTotal = parseInt(totalPrice) / 100;
        const percentage = Math.min((cartTotal / this.goalPrice) * 100, 100);
        const message = this.getText(cartTotal);
        const classLabel = this.getClassLabel(percentage);

        this.updateProgressBar(percentage, message, classLabel);

        // PG: auto-add Kit quando carrinho atinge o threshold (so para barra do Kit, que tem data-label-missing)
        if (this.dataset.labelMissing && this.dataset.labelComplete && cartTotal >= this.goalPrice) {
            var kitBtn = document.querySelector('[data-pg-kit-btn]');
            if (kitBtn && window.pgAddKitBrinde && !window.__pgKitAdding) {
                window.pgAddKitBrinde(kitBtn);
            }
        }
    }

    getText(cartTotal) {
        // PG: textos customizados via data-label-missing / data-label-complete (usa [valor] como placeholder do que falta)
        if (this.dataset.labelMissing && this.dataset.labelComplete) {
            if (cartTotal === 0) {
                this.progressBar.classList.add('progress-hidden');
                return '';
            }
            this.progressBar.classList.remove('progress-hidden');
            if (cartTotal >= this.goalPrice) {
                return this.dataset.labelComplete;
            }
            const missingC = this.goalPrice - cartTotal;
            return this.dataset.labelMissing.replace('[valor]', Shopify.formatMoney(missingC * 100, window.money_format));
        }

        const { t0, t1, t2, t3, t4 } = FreeShippingMeter.texts;

        if (cartTotal === 0) {
            this.progressBar.classList.add('progress-hidden');
            return `<span>${t0} ${Shopify.formatMoney(this.goalPrice * 100, window.money_format)}!</span>`;
        }

        this.progressBar.classList.remove('progress-hidden');

        if (cartTotal >= this.goalPrice) {
            return t1;
        } else {
            const missing = this.goalPrice - cartTotal;
            return `<span>${t2} </span>${Shopify.formatMoney(missing * 100, window.money_format)}<span> ${t3} </span><span class="text">${t4}</span>`;
        }
    }

    getClassLabel(percent) {
        if (percent === 0) return 'none';
        if (percent <= 30) return FreeShippingMeter.classLabel1;
        if (percent <= 60) return FreeShippingMeter.classLabel2;
        if (percent < 100) return FreeShippingMeter.classLabel3;
        return 'progress-free';
    }

    updateProgressBar(percent, message, classLabel) {
        setTimeout(() => {
            this.resetProgressClass();
            this.progressBar.classList.add(classLabel);
            this.progressMeter.style.width = `${percent}%`;

            if (this.textEnabled) {
                this.progressMeter.querySelector('.text').innerHTML = `${percent.toFixed(2)}%`;
            }

            this.messageElement.innerHTML = message;

            if ((window.show_multiple_currencies && typeof Currency !== 'undefined' && Currency.currentCurrency !== shopCurrency) || window.show_auto_currency) {
                const activeCurrency = document.querySelector('#currencies .active');
                const currencyCode = activeCurrency ? activeCurrency.getAttribute('data-currency') : null;
                if (currencyCode) {
                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }
            }
        }, 400);
    }

    resetProgressClass() {
        this.progressBar.classList.remove('progress-30', 'progress-60', 'progress-100', 'progress-free');
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
});
